<template>
  <div>
    <template v-if="form">
      <div class="mb-6 card">
        <div class="card-header">
          Name
        </div>
        <div class="p-6">
          <input type="text" :placeholder="automationTypes[form.type].name" class="form-input" v-model="form.name">
        </div>
      </div>
      <component
        :is="form.type"
        :form="form"
        :methods="methods" />
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import MultiAreaChange from '@/views/automations/types/MultiAreaChange'
  import AreaChange from '@/views/automations/types/AreaChange'
  import ContinuousDrivingTime from '@/views/automations/types/ContinuousDrivingTime'
  import ContinuousDrivingDistance from '@/views/automations/types/ContinuousDrivingDistance'
  import DriverLoginReminder from '@/views/automations/types/DriverLoginReminder'
  import ExceedingAbsoluteSpeedLimit from '@/views/automations/types/ExceedingAbsoluteSpeedLimit'
  import ExceedingRoadSpeedLimit from '@/views/automations/types/ExceedingRoadSpeedLimit'
  import ExceedingVehicleSpeedLimit from '@/views/automations/types/ExceedingVehicleSpeedLimit'
  import ExcessiveIdling from '@/views/automations/types/ExcessiveIdling'
  import ExcessiveStandstill from '@/views/automations/types/ExcessiveStandstill'
  import FuelLevelChange from '@/views/automations/types/FuelLevelChange'
  import HealthCheck from '@/views/automations/types/HealthCheck'
  import IgnitionChange from '@/views/automations/types/IgnitionChange'
  import PanicButton from '@/views/automations/types/PanicButton'

  export default {
    name: 'AutomationForm',

    props: {
      form: {
        type: Object,
        required: true
      },

      methods: {
        type: Object,
        required: true
      }
    },

    components: {
      MultiAreaChange,
      AreaChange,
      ContinuousDrivingTime,
      ContinuousDrivingDistance,
      DriverLoginReminder,
      ExceedingAbsoluteSpeedLimit,
      ExceedingRoadSpeedLimit,
      ExceedingVehicleSpeedLimit,
      ExcessiveIdling,
      ExcessiveStandstill,
      FuelLevelChange,
      HealthCheck,
      IgnitionChange,
      PanicButton
    },

    computed: {
      ...mapState(['automationTypes'])
    }
  }
</script>